import React from "react";
import ServicePage from "../../components/services/create/ServicePage";
import { useTour } from "../../context/TourContext";
import { useUserStore } from "../../state";
import { useCreateServiceTourGuide } from "../../components/tourGide/useCreateServiceTourGuide";
import { useCompanyStore } from "../../state/useCompanyStore";

const CreateServicePage = () => {
  const { registerSteps, startTour } = useTour();
  const { company: user } = useCompanyStore();
  const { createServiceTourGuide } = useCreateServiceTourGuide();

  registerSteps("createService", [...createServiceTourGuide]);

  React.useEffect(() => {
    if (user?.prefs?.isFirstService && !!user.businessType) {
      startTour("createService");
    }
  }, [registerSteps]);
  return (
    <>
      <ServicePage showBack={false} />
    </>
  );
};

export { CreateServicePage };
